import browser from "webextension-polyfill";
import { detectionEventName, detectionMessage } from "../shared";
function forwardDetectionEvent() {
    void browser.runtime.sendMessage({ type: detectionMessage });
}
function start() {
    document.addEventListener(detectionEventName, forwardDetectionEvent);
}
start();
